import React from "react";
import { captureSentryException } from "../../utils/sentry";
import { PmErrorState } from "./PmErrorState";

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
};

export class OpsErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    captureSentryException(error, { extra: { componentStack: info.componentStack } });
  }

  render() {
    if (this.state.hasError) {
      return (
        <PmErrorState
          variant="load_error"
          layout="page"
          onRetry={() => window.location.reload()}
        />
      );
    }

    return this.props.children;
  }
}

export default OpsErrorBoundary;
